export default __webpack_public_path__ + "static/media/500px.cf18458f.svg";